export default {
  relatedTitle: 'Illustrations Connexes',
};
